(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-subscribe"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('es-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('es-btn');
      var btnText = document.getElementById('es-btn-text');
      var errEl = document.getElementById('es-error');
      var nameVal = document.getElementById('es-name').value.trim();
      var emailVal = document.getElementById('es-email').value.trim();

      errEl.style.display = 'none';

      if (!nameVal) {
        errEl.textContent = 'Please enter your first name.';
        errEl.style.display = 'block';
        return;
      }
      if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        errEl.textContent = 'Please enter a valid email address.';
        errEl.style.display = 'block';
        return;
      }

      btn.disabled = true;
      btnText.textContent = 'Subscribing...';

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SwJASt', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: 'X8B6Yn',
              custom_source: 'website-homepage',
              email: emailVal,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: emailVal,
                    first_name: nameVal
                  }
                }
              }
            }
          }
        })
      })
      .then(function(res) {
        if (res.status === 202 || res.status === 200) {
          document.getElementById('es-section-content').style.display = 'none';
          document.getElementById('es-success').style.display = 'flex';
        } else {
          return Promise.reject(res.status);
        }
      })
      .catch(function() {
        errEl.textContent = 'Something went wrong — please try again.';
        errEl.style.display = 'block';
        btn.disabled = false;
        btnText.textContent = '{{ section.settings.button_text }}';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-popup"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* Don't show if already signed up or dismissed */
    if (document.cookie.indexOf('wa_popup_seen=1') !== -1) return;

    /* Don't show on the WhatsApp signup page itself */
    if (window.location.pathname.indexOf('/pages/whatsapp') !== -1) return;

    var overlay = document.getElementById('wa-popup-overlay');
    if (!overlay) return;

    /* Show after 5 second delay */
    setTimeout(function() {
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }, 5000);

    /* Close popup */
    function closePopup() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      /* Set cookie — don't show again for 30 days */
      var d = new Date();
      d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
      document.cookie = 'wa_popup_seen=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    }

    document.getElementById('wa-popup-close').addEventListener('click', closePopup);

    /* Close on overlay click (not card) */
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closePopup();
    });

    /* Close on Escape key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.style.display === 'flex') closePopup();
    });

    /* Form submission */
    var form = document.getElementById('wa-popup-form');
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var btn = document.getElementById('wa-popup-submit');
      var errEl = document.getElementById('wa-popup-error');
      var nameVal = document.getElementById('wa-popup-name').value.trim();
      var phoneVal = document.getElementById('wa-popup-phone').value.trim();

      errEl.style.display = 'none';
      btn.disabled = true;
      btn.textContent = 'Joining...';

      fetch('https://xaatwhjmhpzpbdysxndh.supabase.co/functions/v1/collect-consent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone_e164: phoneVal,
          first_name: nameVal,
          source: 'popup'
        })
      })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(function(data) { throw new Error(data.error || 'Something went wrong'); });
        }
        document.getElementById('wa-popup-form-state').style.display = 'none';
        document.getElementById('wa-popup-success-state').style.display = 'block';

        /* Set cookie so popup doesn't show again */
        var d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        document.cookie = 'wa_popup_seen=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';

        /* Auto-close after 3 seconds */
        setTimeout(closePopup, 3000);
      })
      .catch(function(err) {
        errEl.textContent = err.message || 'Could not save. Please check your number and try again.';
        errEl.style.display = 'block';
        btn.disabled = false;
        btn.textContent = 'Get My 15% Off Code';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-signup"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('wa-section-form');
    if (!form) return;

    // GA4 event helper — uses gtag (Shopify Google & YouTube channel) with dataLayer fallback.
    function waTrack(eventName, params) {
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', eventName, params || {});
        } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
        }
      } catch (err) { /* never block signup on analytics */ }
    }

    // Fire whatsapp_section_view once when the section scrolls into view.
    var section = document.querySelector('.wa-section');
    if (section && 'IntersectionObserver' in window) {
      var seen = false;
      var io = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && !seen) {
            seen = true;
            waTrack('whatsapp_section_view', { section: 'whatsapp_signup', location: window.location.pathname });
            io.disconnect();
          }
        }
      }, { threshold: 0.4 });
      io.observe(section);
    }

    function normalisePhone(raw) {
      var n = raw.replace(/\s+/g, '').replace(/[^\d+]/g, '');
      if (n.startsWith('07') && n.length === 11) return '+44' + n.slice(1);
      if (n.startsWith('447') && n.length === 12) return '+' + n;
      if (n.startsWith('+44')) return n;
      return n;
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('wa-s-btn');
      var btnText = document.getElementById('wa-s-btn-text');
      var errEl = document.getElementById('wa-s-error');
      var nameVal = document.getElementById('wa-s-name').value.trim();
      var phoneRaw = document.getElementById('wa-s-phone').value.trim();
      var phone = normalisePhone(phoneRaw);

      errEl.style.display = 'none';
      if (!nameVal) { errEl.textContent = 'Please enter your first name.'; errEl.style.display = 'block'; return; }
      if (!phoneRaw || phone.length < 10) { errEl.textContent = 'Please enter a valid mobile number.'; errEl.style.display = 'block'; return; }

      waTrack('whatsapp_signup_click', { section: 'whatsapp_signup', location: window.location.pathname });

      btn.disabled = true;
      btnText.textContent = 'Joining...';

      fetch('https://xaatwhjmhpzpbdysxndh.supabase.co/functions/v1/collect-consent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone_e164: phone, first_name: nameVal, source: 'website' })
      })
      .then(function(res) { return res.ok ? res : Promise.reject(res.status); })
      .then(function() {
        waTrack('whatsapp_signup_success', { section: 'whatsapp_signup', location: window.location.pathname });
        document.getElementById('wa-section-content').style.display = 'none';
        document.getElementById('wa-section-success').style.display = 'flex';
      })
      .catch(function() {
        errEl.textContent = 'Something went wrong — please try again.';
        errEl.style.display = 'block';
        btn.disabled = false;
        btnText.textContent = '{{ section.settings.button_text }}';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
